import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ModelAnalytics } from "../../common/organisation";

@Component({
    selector: 'app-analytics-table',
    templateUrl: './analytics-table.html',
    styleUrl: './analytics-table.css',
    standalone: false
})
export class AnalyticsTableComponent implements OnInit {
    @Input() data: ModelAnalytics[]

    displayedColumns:string[] = ['createdDate', 'userName', 'newNodes', 'nodeChanges', 'deletedNodes', 'newEdges', 'edgeChanges', 'deletedEdges']
    displayedColumnHeaders:string[] = ['Date', 'User', 'New nodes', 'Changed nodes', 'Deleted Nodes', 'New Edges', 'Changed edges', 'Deleted Edges']

    dataSource = new MatTableDataSource<ModelAnalytics>();

    @ViewChild(MatSort) sort!: MatSort;
    
    constructor() {
    }

    ngOnInit() {
        this.dataSource.data = this.sortByDate("desc")
        this.dataSource.sort = this.sort
    }

    sortByDate(direction:string) {
        return this.data.sort((a,b) => {
            const aDate = new Date(a.createdDate)
            const bDate = new Date(b.createdDate)
            return direction==="asc"?aDate.getTime()-bDate.getTime():bDate.getTime()-aDate.getTime()
        })
    }

    sortChange(event) {
        if (event.direction!=='') {
            if (event.active === 'createdDate') this.dataSource.data = this.sortByDate(event.direction)
            else {
                this.dataSource.data = this.dataSource.data.sort((a,b) => {
                    if (event.direction === "asc") return a[event.active]>b[event.active]?1:-1
                    else return a[event.active]>b[event.active]?-1:1
                })
            }
        }
    }
}